import React, { useEffect, useRef } from 'react'

export const ThreeJs = ({ threeJsScript }: { threeJsScript: string }) => {
  const divRef = useRef<HTMLDivElement>(null)
  const isFirstRender = useRef(true)

  const html = `
    <script type="importmap">
      {
        "imports": {
          "three": "https://unpkg.com/three@0.176.0/build/three.module.js",
          "three/examples/jsm/math/ImprovedNoise": "https://unpkg.com/three@0.176.0/examples/jsm/math/ImprovedNoise.js"
        }
      }
    </script>
    <script type="module">
      const THREE = await import('three');
      const { ImprovedNoise } = await import('three/examples/jsm/math/ImprovedNoise');
      window.THREE = THREE;
      window.ImprovedNoise = ImprovedNoise;
      ${threeJsScript}
    </script>
  `

  useEffect(() => {
    if (!html || !divRef.current || !isFirstRender.current) return
    isFirstRender.current = false

    const slotHtml = document.createRange().createContextualFragment(html)
    divRef.current.innerHTML = ''
    divRef.current.appendChild(slotHtml)
  }, [html, divRef])

  return (
    <>
      <div id="animationContainer" />
      <div className="hidden" ref={divRef} />
    </>
  )
}
